import { render, staticRenderFns } from "./DeliveryTable.vue?vue&type=template&id=f4d3bd86&scoped=true"
import script from "./DeliveryTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DeliveryTable.vue?vue&type=style&index=0&id=f4d3bd86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d3bd86",
  null
  
)

export default component.exports